/**
 * Tworzy uproszczoną kartę produktu na podstawie danych z Elastic.
 * Funkcja jest używana jako fallback, gdy listing nie zwróci HTML.
 */
export const createCard = (data, currency = 'zł') => {
    const {
        permalink = '#',
        post_title = '',
        thumbnail_url = '',
        regular_price = null,
        sale_price = null,
        product_brand = [],
    } = data || {};

    const brandName =
        Array.isArray(product_brand) && product_brand.length
            ? product_brand[0]?.name || ''
            : '';

    const card = document.createElement('li');
    card.innerHTML = `
        <article class="wc-product-box group flex flex-col">
            <a href="${permalink}" class="block overflow-hidden rounded-[12px] border border-neutral-100 bg-white p-3">
                <div class="aspect-[1/1] overflow-hidden rounded-[10px] bg-neutral-50">
                    ${thumbnail_url ? `<img src="${thumbnail_url}" alt="${post_title}" class="h-full w-full object-contain">` : ''}
                </div>
                <div class="mt-3">
                    ${brandName ? `<p class="text-p-small uppercase tracking-[0.02em] text-neutral-500">${brandName}</p>` : ''}
                    <h3 class="text-p-regular font-semibold text-neutral-900">${post_title}</h3>
                    <p class="mt-2 text-h6 text-neutral-900">
                        ${sale_price ? `${sale_price} ${currency}` : `${regular_price || 0} ${currency}`}
                    </p>
                </div>
            </a>
        </article>
    `;

    return card;
};
